<template>
  <div class="helpful-links cell small-12 medium-12 large-12 padding-top-m margin-bottom-m grid-container">
    <div class="cell grid-x margin-bottom-s">
      <span
        id="rnowChatLinkContainer_type7"
        class="chat-now-container"
      >
        <span
          class="h3"
          v-text="helpFulLinksHeader"
        ></span>
      </span>
    </div>
    <ul class="grid-x grid-margin-x grid-margin-y align-middle">
      <li
        v-for="(link, index) in helpLinks"
        :key="index"
        :class="calcAlignment(index)"
        class="cell small small-12 mlarge-4 medium-6 large-6 margin-bottom-s"
      >
        <a
          v-if="link.attachEvent"
          href="javascript:void(0)"
          title="removeBronze"
          @click.stop="openConfirmRemoveModal"
          >{{ link.linkName }}
        </a>
        <a
          v-else
          :href="link.linkUrl"
          target="_blank"
          >{{ link.linkName }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { brand, helpFulLinksHeader } from '../../config';
import helpLinksData from './links.json';
import { loadOverlayComponent } from '../../utils/loadOverlayComponent';
import { useLoyaltyHubStore } from '../../stores/useLoyaltyHubStore.js';
import { useModalOverlayStore } from '../../stores/useModalOverlayStore';

const loyaltyHub = useLoyaltyHubStore();
const modalOverlayStore = useModalOverlayStore();

const tierName = computed(() => loyaltyHub.tierName);

const helpLinks = computed(() => helpLinksData[brand][tierName.value]);

const calcAlignment = (index) => {
  const i = index + 1;
  let alignment;
  if (i % 3 === 2) {
    // middle
    alignment = 'mlarge-text-left mlarge-padding-left-l';
  } else if (i % 3 === 0) {
    // right
    alignment = 'mlarge-text-right';
  } else if (i % 3 === 1) {
    // left
    alignment = 'mlarge-text-left';
  }
  return i % 2 === 0 ? `${alignment} medium-text-right` : alignment;
};

// mutation
const toggleModal = async (val) => {
  if (modalOverlayStore.showModal[val]) {
    modalOverlayStore.close(val);
  } else {
    modalOverlayStore.toggle(val);
  }
};
const setOverlay = async (val) => {
  modalOverlayStore.setModalOverlay(val);
};

const openConfirmRemoveModal = async () => {
  const component = await loadOverlayComponent('confirmRemove');
  await toggleModal('loyaltyIdModal');
  await setOverlay({
    width: '32%',
    id: 'confirmRemoveModal',
    title: 'Are you sure?',
    component,
  });
  await toggleModal('confirmRemoveModal');
};
</script>

<style lang="scss">
ul {
  list-style-type: none;
}
</style>


<style lang="scss" scoped>
@import '~@core/csg/src/scss/settings/bcom.scss';
.h3 {
  letter-spacing: $h3-letter-spacing;
}
.helpful-links ul li a {
  font-size: rem-calc(12);
  line-height: rem-calc(16);
}

.helpful-links ul.grid-x {
  @include breakpoint(medium up) {
    white-space: nowrap;
  }
}
</style>